<div class="ui-g campaign-list">

  <div class="ui-g-12">
    <p-messages [(value)]="errors"></p-messages>
  </div>

  <div class="ui-g-12 ui-lg-6">
    <h1>{{ 'campaign.allCampaign' | translate }}</h1>
  </div>

  <div class="ui-g-12 ui-lg-6 text-right">
    <button pButton type="button" class="k-generic-btn" icon="fa fa-plus-circle" iconPos="left" label="{{ 'menu.campaingManagerNew' | translate }}" routerLink="/new-campaign"></button>
  </div>

  <div class="ui-g-12 summary">
    <div class="ui-g-4 summary-box">
      <div class="summary-box-title">{{ budget | numberKM }} &euro;</div>
      <div class="summary-box-desc">{{ 'campaign.totalYear' | translate }}</div>
    </div>
    <div class="ui-g-4 summary-box">
      <div class="summary-box-title">{{ budgetPercentage }}%</div>
      <div class="summary-box-desc">{{ 'campaign.budgetProgress' | translate }}</div>
      <p-progressBar [value]="budgetPercentage" [showValue]="false"></p-progressBar>
    </div>
    <div class="ui-g-4 summary-box">
      <div class="summary-box-title">{{ timePercentage }}%</div>
      <div class="summary-box-desc">{{ 'campaign.timeProgress' | translate }}</div>
      <p-progressBar [value]="timePercentage" [showValue]="false"></p-progressBar>
    </div>
  </div>

  <div class="ui-g-12 ui-g-nopad filter">
    <div class="ui-g-3 ui-g-nopad">
      <label>{{ 'common.name' | translate }}</label>
      <input class="campaign-name" type="text" [(ngModel)]="filterName" (change)="campaignFilter()" />
    </div>
    <div class="ui-g-3 ui-g-nopad">
      <label>{{ 'common.from' | translate }}</label>
      <p-calendar
        *ngIf="calendarTranslate"
        [(ngModel)]="filterFromDate"
        [showIcon]="true"
        [locale]="calendarTranslate"
        [dateFormat]="calendarTranslate.dateFormat"
        [placeholder]="calendarTranslate.dateFormat"
        [readonlyInput]="true"
        (onSelect)="campaignFilter()"
      ></p-calendar>
    </div>
    <div class="ui-g-3 ui-g-nopad">
      <label>{{ 'common.to' | translate }}</label>
      <p-calendar
        *ngIf="calendarTranslate"
        [(ngModel)]="filterToDate"
        [minDate]="filterFromDate"
        [showIcon]="true"
        [locale]="calendarTranslate"
        [dateFormat]="calendarTranslate.dateFormat"
        [placeholder]="calendarTranslate.dateFormat"
        [readonlyInput]="true"
        (onSelect)="campaignFilter()"
      ></p-calendar>
    </div>
    <div class="ui-g-3 ui-g-nopad text-right">
      <label>{{ 'common.name' | translate }}</label>
      <p-dropdown [options]="filterTypes" [(ngModel)]="filterSelectedType" (onChange)="campaignFilter()"></p-dropdown>
      <p-dropdown [options]="filterStores" [(ngModel)]="filterSelectedStore" (onChange)="campaignFilter()" [filter]="true" filterBy="label,value"></p-dropdown>
    </div>
  </div>

  <div class="ui-g-12 ui-g-nopad filter">
    <div class="ui-g-1 ui-g-nopad" style="padding-top: 12px;">
      <label>{{ 'common.status' | translate }}</label>
    </div>
    <div class="ui-g-11 ui-g-nopad">
      <div class="ui-g-2 status-button" *ngFor="let status of filterStatusButtons">
        <button pButton type="button" class="roundedButton slim border status status-{{ status.value.toLowerCase() }}" label="{{ status.label }}" [ngClass]="{'active': filterStatus == status.value}" (click)="setStatus(status.value)"></button>
      </div>
    </div>
  </div>

  <div class="ui-g-12 ui-g-nopad filter sort-menu">
    <div class="ui-g-6 ui-g-nopad" style="padding-top: 12px;">
      <label>{{ campaignList.length }}</label> {{ 'campaign.campaigns' | translate }}
    </div>
    <div class="ui-g-6 ui-g-nopad text-right">
      <label>Sorting</label>
      <p-dropdown [options]="filterSort" [(ngModel)]="filterSelectedSort" (onChange)="campaignFilter()"></p-dropdown>
    </div>
  </div>

  <p-paginator *ngIf="campaignList && pagination && campaignList.length > pagination.step" [rows]="pagination.step" [totalRecords]="pagination.total" (onPageChange)="paginate($event)"></p-paginator>

  <div class="ui-g-12 ui-g-nopad list">
    <div class="list-item" *ngFor="let campaign of campaignListPage">
      <div class="icons text-right">
        <a *ngFor="let action of campaign.actions" class="fa fa-{{ action.value.icon }}" routerLink="{{ action.value.link }}" [queryParams]="{ campaign: campaign.campaign_name }"></a>

        <!-- Chiusura Campagna? -->
        <!-- <a class="fa fa-power-off" (click)=""></a> -->

        <!-- Eliminazione Campagna -->
        <a *ngIf="campaign.campaign_state_id < 7" class="fa fa-trash" (click)="deleteCampaign(campaign.campaign_name)"></a>

      </div>

      <div class="campaign-name status-{{ campaign.campaign_state_key.toLowerCase() }}">
        {{ campaign.campaign_name }}
      </div>

      <div class="campaign-details ui-g ui-g-nopad">
        <div class="ui-g-6">
          Durata <strong *ngIf="calendarTranslate">{{ campaign.start_date | date: calendarTranslate.dateFormatFilter }} - {{ campaign.end_date | date: calendarTranslate.dateFormatFilter }}</strong>
        </div>
        <div class="ui-g-6">
          Budget <strong>{{ campaign.budget | numberKM }} &euro;</strong>
        </div>
        <div class="ui-g-6">
          Tipo <strong>{{ campaign.campaign_type_name }}</strong>
        </div>
        <div class="ui-g-6">
          Stato <strong>{{ campaign.campaign_state.toUpperCase() }}</strong>
        </div>
      </div>

    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/campaignlist/campaignlist.component.html